/*
 * @Descripttion: 文件API集合
 * @version:
 * @Author: luoxi
 * @Date: 2019年11月30日15:52:24
 * @LastEditors: wanglong
 * @LastEditTime: 2021-09-03 11:09:43
 */

import request from "@/plugins/axios";
import { data } from "jquery";

//根据邮箱获取验证码
export function getCode(email) {
  return request({
    url: "/apply/email_capcha/" + email,
    method: "get",
  });
}

//根据地区树
export function getregion() {
  return request({
    url: "/web/region/tree",
    method: "get",
  });
}

//注册
export function register(data) {
  return request({
    url: "/apply/register",
    method: "post",
    data: data,
  });
}

//获取登录验证码

export function logincapcha() {
  return request({
    url: "/apply/create_capcha",
    method: "get",
  });
}

//登录
export function userlogin(data) {
  return request({
    url: "/apply/login",
    method: "post",
    data: data,
  });
}

//获取用户信息
export function user_info() {
  return request({
    url: "/web/user/user_info",
    method: "get",
  });
}

//修改用户信息
export function updateuserinfo(data) {
  return request({
    url: "/web/user/update",
    method: "post",
    data: data,
  });
}

//重置密码
export function update_password(data) {
  return request({
    url: "/web/user/update_password",
    method: "post",
    data: data,
  });
}
//退出登录
export function login_out(type) {
  return request({
    url: "/apply/login_out/" + type,
    method: "get",
  });
}

//报名列表
export function applylist(data) {
  return request({
    url: "/web/apply/list",
    method: "post",
    data: data,
  });
}
//报名列表详情
export function apply_detail(data) {
  return request({
    url: "/web/apply/apply_detail",
    method: "post",
    data: data,
  });
}

//提交、保存报名申请模板二
export function applysubmit(data) {
  return request({
    url: "/web/apply/submit_template2",
    method: "post",
    data: data,
  });
}

//文件上传
export function upload(data) {
  return request({
    url: "/web/upload",
    method: "post",
    data: data,
  });
}

//支付接口
export function pay_to(data) {
  return request({
    url: "/web/pay/pay_to",
    method: "post",
    data: data,
  });
}

//上传分享地址
export function upload_share(data) {
  return request({
    url: "/web/apply/upload_share",
    method: "post",
    data: data,
  });
}
//缴费查询
export function pay_detail(id) {
  return request({
    url: "/web/pay/pay_detail/" + id,
    method: "get",
  });
}

//申请开票
export function payinvoice(data) {
  return request({
    url: "/web/pay/invoice",
    method: "post",
    data: data,
  });
}

///获取模板附件下载地址
export function templateup(id) {
  return request({
    url: "/web/apply/template/" + id,
    method: "get",
  });
}

/**
 * 得到用户信息token
 *
 *
 **/
export function gettoken(data) {
  return request({
    url: "/call/back/redirect/" + data,
    method: "get",
    data: data,
  });
}

/**
 * 得到用户信息
 *
 *
 **/
export function getSaveInfo(data) {
  return request({
    url: "/base/user/getSaveInfo",
    method: "post",
    data: data,
  });
}
/**
 * 修改用户信息
 *
 *
 **/
export function ubdatainfo(data) {
  return request({
    url: "/base/user/update/saveinfo",
    method: "post",
    data: data,
  });
}

//修改报名申请模板二
export function applyupdate(data) {
  return request({
    url: "/web/apply/update_web_template2",
    method: "post",
    data: data,
  });
}

//获取团队信息
export function team_info() {
  return request({
    url: "/web/apply/team_info",
    method: "get",
  });
}

//通过活动id获取模板元数据
export function templatetype(id) {
  return request({
    url: "/web/apply/template_metadata/" + id,
    method: "get",
  });
}

//根据项目id查询用户表单字段
export function listFormFieldByProjectId(id) {
  return request({
    url: "/web/metadataManager/listFormFieldByProjectId/" + id,
    method: "get",
  });
}

//导出报名表
export function applyExport(id) {
  return request({
    url: "/web/apply/applyExport/" + id,
    method: "get",
    responseType: "blob",
  });
}

//获取收款码信息
export function dueinfo() {
  return request({
    url: "/web/due/info",
    method: "get",
  });
}

//获取下载活动附件
export function activity_file(id) {
  return request({
    url: "/web/apply/activity_file/" + id,
    method: "get",
    responseType: "blob",
  });
}

//下载自定义表单
export function tplDetailById(id) {
  return request({
    url: "/web/metadataManager/tplDetailById/" + id,
    method: "get",
  });
}

//下载自定义表单
export function addMetadataTemplate(data) {
  return request({
    url: "/web/apply/addMetadataTemplate",
    method: "post",
    data: data,
  });
}

//编辑自定义表单
export function updateMetadataTemplate(data) {
  return request({
    url: "/web/apply/updateMetadataTemplate",
    method: "post",
    data: data,
  });
}

//查询自定义表单
export function selectMetadataTemplateDetail(data) {
  return request({
    url: "/web/apply/selectMetadataTemplateDetail",
    method: "post",
    data: data,
  });
}

//忘记密码
export function forgetPassWord(data) {
  return request({
    url: "/apply/forgetPassWord",
    method: "post",
    data: data,
  });
}

//忘记密码
export function checkEmail(params) {
  return request({
    url: "/apply/check",
    method: "get",
    params,
  });
}
